export default "/images/secondary-theme.png?57b99c7e6d5328e6b683c6a40fcb2c14";